import { render, staticRenderFns } from "./tenantAlgorithmicCalculationDetails.vue?vue&type=template&id=214d6463&scoped=true"
import script from "./tenantAlgorithmicCalculationDetails.vue?vue&type=script&lang=js"
export * from "./tenantAlgorithmicCalculationDetails.vue?vue&type=script&lang=js"
import style0 from "./tenantAlgorithmicCalculationDetails.vue?vue&type=style&index=0&id=214d6463&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214d6463",
  null
  
)

export default component.exports